import { AppState } from '../../types';

export const selectPaymentMethod = (state: AppState) => state.billing.paymentMethod;

export const selectInvoices = (state: AppState) => state.billing.invoices;

export const selectCreateCustomInvoiceLoading = (state: AppState): boolean => state.billing.createInvoice.createInvoiceLoading;
